import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usage-information-popover',
  templateUrl: './usage-information-popover.component.html',
  styleUrls: ['./usage-information-popover.component.scss'],
})
export class UsageInformationPopoverComponent implements OnInit {

  public infoToDisplay: number;
  constructor() { }

  ngOnInit() { }

}
